
import {mapActions, mapState} from 'vuex'
import addDoc from "@/components/addDoc.vue";
import {Toast} from "vant";
import {getFileSuffix} from "../utils";

  export default {
    components: {addDoc},
    props: {
      lists: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    data() {
      return {
        isDoc: false,
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['addDoc']),
      dele(index) {
        this.$emit('ondele', index)
      },
      showAddDoc() {
        if(this.lists !='' ){
          Toast(this.$t('append_field.oneDoc'))
          return
        }
        this.isDoc = true
      },
      getDoc(data) {
        this.addDoc(data)
        this.isDoc = false
      },
      close() {
        this.isDoc = false
      },
      clear() {
        this.$emit('clear')
      },
      getDocUrl(item) {
        if (item && item.url) {
          const suffix = '.' + getFileSuffix(item.name)
          const pptExt = ['.ppt', '.pptx', '.pot', '.potx', '.pps', '.ppsx', '.dps', '.dpt', '.pptm', '.potm', '.ppsm', '.dpss']
          const wordExt = ['.doc', '.docx', '.wps', '.wpss', '.docm', '.dotm', '.dot', '.dotx', '.html']

          if (suffix === '.pdf') {
            return  '/static/images/program/pdf.png'
          } else if (suffix === '.xlsx' || suffix === '.xls') {
            return  '/static/images/program/xlsx.png'
          } else if (pptExt.includes(suffix)) {
            return  '/static/images/program/ppt.png'
          } else if (suffix === '.txt') {
            return  '/static/images/program/txt.png'
          } else if (wordExt.includes(suffix)) {
            return  '/static/images/program/word.png'
          }
        }
        // 如果 item 或 item.suffix 为空，返回一个默认图片或处理逻辑
        //return "/static/images/icon_loader_failed.png"
      }
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
